/**
 * Simulation control slice — play / pause, rate, last tick. The engine itself
 * runs in the React tree (a small useEffect-driven loop) so it can grab the
 * latest state on every tick without subscribing to every change.
 */
import { create } from 'zustand';

interface SimState {
  /** True when the simulator is ticking. */
  running: boolean;
  /** Time multiplier — 1× real time, 5×, 30×. */
  rate: number;
  /** Whether the primary track should record the simulated motion. */
  recordTrack: boolean;
  setRunning: (on: boolean) => void;
  setRate: (rate: number) => void;
  setRecordTrack: (on: boolean) => void;
}

export const useSimStore = create<SimState>((set) => ({
  running: true,
  rate: 1,
  recordTrack: true,
  setRunning: (running) => set({ running }),
  setRate: (rate) => set({ rate }),
  setRecordTrack: (recordTrack) => set({ recordTrack }),
}));
